<template>
    <div>
        <vs-dialog blur v-model="intouch_dialog">
        <template #header>
          <h4 class="not-margin">Confirmation Depot</h4>
        </template>
        <div class="con-form">
          <div class="center examplex">
            <vs-table striped>
              <template #tbody>
                <vs-tr>
                  <vs-th> MOYEN DE PAIEMENT </vs-th>
                  <vs-th> <vs-select placeholder="Select" v-model="type">
                      <vs-option label="AIRTEL-GABON" value="AIRTEL-GABON">
                        <vs-avatar size="20">
                          <img src="/img/airtel.png" alt="">
                        </vs-avatar>
                        AIRTEL-GABON
                      </vs-option>
                      <vs-option label="MOOV-GABON" value="MOOV-GABON">
                        <vs-avatar size="20">
                          <img src="/img/moov.png" alt="">
                        </vs-avatar>
                        MOOV-GABON
                      </vs-option>
                    </vs-select> 
                </vs-th>
                </vs-tr>
                <p class="red--text" v-if="choose_method">veuillez choisir un moyen de paiement</p>
                <vs-tr>
                  <vs-th> MONTANT </vs-th>
                  <vs-th style="font-size: 1.5em">{{montant}} </vs-th>
                </vs-tr>
                <vs-tr>
                  <vs-th> NUMERO sans indicatif </vs-th>
                  <vs-th><vs-input type="number" v-model="phone_number" placeholder="Numero sans indicatif" style="font-size: 1.7em" /> </vs-th>
                </vs-tr>
                
              </template>
            </vs-table>
          </div>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-button block @click="intouch">
              Deposer
            </vs-button>
          </div>
        </template>
      </vs-dialog>

      <v-dialog
      v-model="valid_om_mali"
      fullscreen 
      persistent :overlay="false"
      transition="dialog-transition"
    >
    <v-card>
       <v-card-title primary-title class="font-weight-bold">
        
       </v-card-title>
       <v-card-text>

        <v-flex xs12 text-xs-center>
                <p
                  class="green--text body-2 font-weight-bold"
                >Finalisez votre votre paiement en suivant les instructions suivantes</p>
                <div v-if="valid_om_mali" class="red--text body-2 font-weight-bold">
                  
                  <v-alert
                    v-model="valid_om_mali"
                      
                    color="success"
                  >
                  
                 Pour finaliser votre paiement veuillez taper: <br> <span class="font-weight-bold" style="font-size: 2em;">*144*code secret orange money#</span><br>
                 si vous ne le faites pas votre paiement ne sera pas validé
                  
                  </v-alert>
                </div>
                <!-- <p class="caption red--text" v-if="moyen=='Flooz'">Veillez choisir Transfert MARCHANT dans les options d'envoi flooz</p> -->
              </v-flex>
         
        
        <v-flex xs12 text-xs-center>
          <v-btn color="primary" @click="valid_om_mali = false">FERMER</v-btn>
        </v-flex>
       </v-card-text>
     </v-card>
      
    </v-dialog>

    </div>
</template>

<script>
import firebase from '../../fb'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
    export default {
        props: {
            amount:String
        },
        data() {
            return {
                intouch_dialog:false,
                otp:'',
                phone_number:'',
                type:'',
                bf_dialog:false,
                valid_om_mali:false
            }
        },
        computed: {
            montant() {
                return this.amount
            },
             choose_method(){
              return this.type.length <3
            }
        },

        mounted () {
           this.$root.$on('intouch_cm', () => {
               this.intouch_dialog= true
            }); 
        },

    methods: {
      
    intouch(){
      if (this.type.length < 3) {
      alert('veuillez choisir un moyen de paiement')
      return
    }

    if (this.montant< 200) {
      alert('montant minimum est de 200 fr')
      return
    }
    if (this.phone_number.length !== 8) {
      alert('veuillez saisir un numero de telephone à 8chiffres')
      return
    }
    const loading = this.$vs.loading()
      let user = firebase.auth().currentUser
      let moyen = this.type
      let idFromClient= ""
      let payload
      let callback_url = `${this.base_url}/intouch/deposit_intouch_callback`

      let serviceCode
      moyen == "AIRTEL-GABON" ? serviceCode = "GAPAIEMENTMARCHANDAIRTEL" : serviceCode = "GAPAIEMENTMARCHANDMOOV"

      payload = {
              "idFromClient": idFromClient,
              "amount": this.montant,
              "callback": callback_url,
              "recipientNumber": this.phone_number,
              serviceCode
            }

      let data ={
          country:'gabon',
          payload,
        user_id:user.uid
      }


      if (this.type.toString().length<5) {
        loading.close()
        this.intouch_dialog = false
        console.log('hello');
        swal("Echec", "veuillez selectionner un moyen de paiement", "error", {button: "ok"});
        setTimeout(() => {
                this.intouch_dialog = true
              }, 2000);

        return
      }

      if (this.phone_number.toString().length != 8) {
        loading.close()
        this.intouch_dialog = false
        console.log('hello');
        swal("Echec", "veuillez saisir un numero a 8 chiffres", "error", {button: "ok"});
        setTimeout(() => {
                this.intouch_dialog = true
              }, 2000);

        return
      }

      let base_url = this.base_url
              if (location.hostname === "localhost") {
                  base_url = 'http://localhost:4000'
                }
    let url = `${base_url}/intouch/deposit_intouch`

      console.log(data);
          axios.post(url,data).then(res=>{
            loading.close()
            console.log(res.data);
            let {status} = res.data
            let notif
            this.intouch_dialog = false
            
            if (status!==300) {
                switch (status) {
                case 'INITIATED': notif = {title:'Dépot en cours', message: 'Veuillez confirmer sur votre telephone'};
                    break;
                case 'SUCCESSFUL': notif = {title:'Operation reussie', message: 'Dépot effectué avec succès'}
                    break;
            
                default:swal("Echec", "Opération échouée", "error", {button: "ok"});
                    break;
                }

                status == "INITIATED" && moyen == 'ORANGE-MALI' ? this.valid_om_mali = true : swal(notif.title, notif.message, "success", {button: "ok"});
                return
            }
            let {message, detailMessage} = res.data
            let error_otp = "(505) Cher client, le OTP utilise nexiste pas."
            let error_phone = "(505) Le numero de telephone saisi est incorrecte."
            let error_subscribe = "(505) NOT SUBSCRIBED"

            let error_notif

            if ( detailMessage==error_otp || message ==error_otp) {
                error_notif = `OTP incorrect, tapez #144*4*${this.montant}#`
            }

            if (detailMessage==error_phone || message ==error_phone || detailMessage==error_subscribe || message ==error_subscribe) {
              error_notif = "Numero de telephone incorrect"
            }

            swal("Echec", error_notif, "error", {button: "ok"});

            setTimeout(() => {
                this.intouch_dialog = true
              }, 4000);
            
      }).catch(e=>{
        console.log(e);
      })

    },
        },
        
    }
</script>

<style lang="scss" scoped>

</style>